import React, { useState, useRef } from "react";
import Draggable, { DraggableBounds } from 'react-draggable';
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Form, Input, Button, Space, InputNumber, Modal } from "antd";
import "./sales_add_line.css";
import { useSalesAddLine, AddLineFormData } from "../../components/hoc_sales_add_line";
import BrowserSparepartsSales from "./browser_spareparts_sales";

interface SalesAddLineProps {
    onSubmit?: (data: AddLineFormData) => void;
    editData?: AddLineFormData | null;
    onCancel?: () => void;
    initialDiscPercent?: number;
}
const SalesAddLine: React.FC<SalesAddLineProps> = ({
    onSubmit,
    editData,
    onCancel,
    initialDiscPercent,
}) => {
    const [disabled, setDisabled] = useState(true);
    const [bounds, setBounds] = useState<DraggableBounds>({ left: 0, top: 0, bottom: 0, right: 0 });
    const draggleRef = useRef<HTMLDivElement>(null);
    const {
        form,
        handleSubmit,
        handleCancelClick,
        handleFormValuesChange,
        isEditMode,
        isDiscPercentDisabled,
        isDiscAmountDisabled,
    } = useSalesAddLine(onSubmit, editData, onCancel, initialDiscPercent);

    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    const [showBrowser, setShowBrowser] = useState(false);

    const handleBrowserClick = () => {
        setShowBrowser(true);
    };

    const handleCloseBrowser = () => {
        setShowBrowser(false);
    };

    const handleSparePartSelected = (item: { item_code: string; item_name: string; uom: string; sales_price: number; qty: number; }) => {
        const fieldsToSet = {
            item_code: item.item_code,
            item_name: item.item_name,
            uom: item.uom,
            price: item.sales_price,
            available_qty: item.qty,
        };
        form.setFieldsValue(fieldsToSet);
        const allValues = form.getFieldsValue();
        const changedValues = fieldsToSet;
        handleFormValuesChange(changedValues, allValues as AddLineFormData);
        setShowBrowser(false);
    };
    return (
        <div id="iau9" style={transformStyle}>
            {/* Grid Row 1 */}
            <div className="gjs-grid-row" id="izqfj">
                <div className="gjs-grid-column" id="iyhzo">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                title: (
                                    <>
                                        <UserOutlined />
                                        <span>Sales Order</span>
                                    </>
                                ),
                            },
                            {
                                title: "Add Order Item Detail",
                            },
                        ]}
                    />
                </div>
            </div>
            {/* Grid Row 2 */}
            <div className="gjs-grid-row" id="i9286">
                <div className="gjs-grid-column" id="i9yd9">
                    {/* Form Horizontal */}
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        onValuesChange={handleFormValuesChange}
                        labelCol={{ style: { width: '190px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item label="Item Code" style={{ marginBottom: 0 }} >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <Form.Item name="item_code" style={{ width: '300px', marginRight: '8px', marginBottom: 5 }}
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Required!',
                                        },
                                    ]}
                                >
                                    <Input placeholder=""
                                    />
                                </Form.Item>
                                <Button name="browser_spareparts" type="primary" className="icon-button" style={{ margin: '0px' }} onClick={handleBrowserClick}>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="icon">
                                        <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                        <path
                                            fillRule="evenodd"
                                            d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                            clipRule="evenodd"
                                        />
                                        <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                    </svg>
                                </Button>
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Item Name"
                            name="item_name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input className="readonly-background" placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Subs"
                            name="subs"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input className="readonly-background" placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="UOM"
                            name="uom"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input className="readonly-background" placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Demand Qty"
                            name="dmd"
                            style={{
                                marginBottom: "5px", maxWidth: '70%'
                            }}
                            rules={[
                                {
                                    required: true,
                                    message: 'Required!',
                                },
                            ]}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Available Qty"
                            name="available_qty"
                            style={{
                                marginBottom: "5px", maxWidth: '70%'
                            }}
                        >
                            <Input className="readonly-background" placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Supply Qty"
                            name="sup"
                            style={{
                                marginBottom: "5px", maxWidth: '70%'
                            }}
                        >
                            <Input className="readonly-background" placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Regional Stock"
                            name="regional_stock"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" />
                        </Form.Item>
                        <Form.Item
                            label="Price"
                            name="price"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <InputNumber className="readonly-background" placeholder=""
                                style={{ width: '80%' }}
                                formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Original Disc Percent"
                            name="original_disc_percent"
                            style={{
                                marginBottom: "5px", maxWidth: '50%'
                            }}
                        >
                            <Input className="readonly-background" placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Original Disc Amount"
                            name="original_disc_amount"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input className="readonly-background" placeholder="" readOnly />
                        </Form.Item>
                        <Form.Item
                            label="Disc Percent"
                            style={{
                                marginBottom: "5px", maxWidth: '50%'
                            }}
                            name="proposal_disc_percent"

                        >
                            <Input
                                className={isDiscPercentDisabled ? "readonly-input" : ""}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Disc Amount"
                            style={{
                                backgroundColor: isDiscAmountDisabled ? '#f5f5f5' : 'white',
                                opacity: isDiscAmountDisabled ? 0.7 : 1
                            }}
                            name="proposal_disc_amount"
                        >
                            <InputNumber
                                style={{ width: '100%' }}
                                disabled={isDiscAmountDisabled}
                                readOnly={isDiscAmountDisabled}
                                className={isDiscAmountDisabled ? "readonly-input" : ""}
                                formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Total"
                            name="total"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <InputNumber
                                className="readonly-background"
                                placeholder=""
                                style={{ width: '100%' }}
                                readOnly
                                formatter={(value) => value ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''}
                                parser={(value) => value ? value.replace(/\$\s?|(,*)/g, '') : ''}
                            />
                        </Form.Item>
                        <Form.Item label="Remark" name="remark_table">
                            <Input.TextArea placeholder="" rows={5} />
                        </Form.Item>
                        <Space style={{ paddingTop: "20px" }}>
                            <Button
                                type="primary"
                                onClick={handleSubmit}
                                style={{
                                    height: "40px",
                                    width: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                                icon={
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                        style={{ width: "22px", height: "22px" }}
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M19.916 4.626a.75.75 0 0 1 .208 1.04l-9 13.5a.75.75 0 0 1-1.154.114l-6-6a.75.75 0 0 1 1.06-1.06l5.353 5.353 8.493-12.74a.75.75 0 0 1 1.04-.207Z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                }
                            >
                                {editData ? 'Edit' : 'OK'}
                            </Button>
                            <Button
                                type="primary"
                                onClick={handleCancelClick}
                                style={{
                                    height: "40px",
                                    width: "120px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "red",
                                    color: "white",
                                    border: "none",
                                }}
                            >
                                Cancel
                            </Button>
                        </Space>
                    </Form>
                </div>
            </div>
            <Modal
                title={
                    <div
                        style={{ width: '100%', cursor: 'move' }}
                        onMouseOver={() => { if (disabled) setDisabled(false); }}
                        onMouseOut={() => { setDisabled(true); }}
                    >
                        Select Spare Part
                    </div>
                }
                open={showBrowser}
                onCancel={handleCloseBrowser}
                footer={null}
                width="fit-content"
                modalRender={(modal) => (
                    <Draggable
                        disabled={disabled}
                        bounds={bounds}
                        nodeRef={draggleRef}
                        onStart={(event, uiData) => {
                            const { clientWidth, clientHeight } = window.document.documentElement;
                            const targetRect = draggleRef.current?.getBoundingClientRect();
                            if (!targetRect) return;
                            setBounds({
                                left: -targetRect.left + uiData.x,
                                right: clientWidth - (targetRect.right - uiData.x),
                                top: -targetRect.top + uiData.y,
                                bottom: clientHeight - (targetRect.bottom - uiData.y),
                            });
                        }}
                    >
                        <div ref={draggleRef}>{modal}</div>
                    </Draggable>
                )}
            >
                <BrowserSparepartsSales
                    isVisible={showBrowser}
                    onClose={handleCloseBrowser}
                    onSelectSparePart={handleSparePartSelected}
                />
            </Modal>
        </div>
    );
};
export default SalesAddLine;